import React from 'react';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useGetDisciplines } from 'helpers/commonCodes';
import SelectorDisciplineCombo from './selectorDisciplineCombo';
import SelectorDisciplineMenu from './selectorDisciplineMenu';
import { SELECTOR_DISPLAY_TYPE, isParalympic } from 'helpers/utils';

export default function SelectorDiscipline({ display_type = SELECTOR_DISPLAY_TYPE.MENU, page = "schedule", disciplinesList, useDisciplinesList = false, displayAllDisc = true }) {
    let params = useUrlFriendlyToParameters();
    let arrHasRecords = (isParalympic(params.mirs_competition) ? process.env.REACT_APP_PARAS_RECORDS_ARRAY : process.env.REACT_APP_RECORDS_ARRAY) || [];


    //get disciplines from memory 
    const data = useGetDisciplines(params);
    let dataFilter

    // id discArray provided, display it.
    if (useDisciplinesList && Array.isArray(disciplinesList)) {
        if (page === "records") {
            dataFilter = data?.disciplines ? data?.disciplines?.filter(item => arrHasRecords.includes(item.code) && disciplinesList.includes(item.code)) : [];
        } else {
            dataFilter = data?.disciplines ? data?.disciplines?.filter(item => disciplinesList.includes(item.code)) : [];
        };
    } else if (page === "records") {
        dataFilter = data?.disciplines ? data?.disciplines?.filter(item => arrHasRecords.includes(item.code)) : [];
    } else {
        dataFilter = data?.disciplines
    }
    return (<>
        {display_type === SELECTOR_DISPLAY_TYPE.MENU ?
            (
                <SelectorDisciplineMenu data={dataFilter} page={page} />
            ) : (
                <SelectorDisciplineCombo data={dataFilter} page={page} displayAllDisc={displayAllDisc} />
            )
        }
    </>

    );
};




